<template>
    <div id="companyCatalogs">

        <TipBox info :title="$t(companyId ? 'catalogs.company_manage_availability' : 'catalogs.manage_availability')" no-border>
            <span v-html="$t(companyId ? 'catalogs.company_manage_availability_description' : 'catalogs.manage_availability_description')"></span>
        </TipBox>
        <br>

        <Panel :title="$t('catalogs.configuration')" v-if="inventory && catalogs.length > 1">
            <div class="columns">
                <div class="column">
                    <div class="group">
                        <label>{{$t('catalogs.select_catalog')}}</label>
                        <select v-model="selectedCatalogId">
                            <option :value="null">{{$t('choose')}}...</option>
                            <option :value="catalog.id" v-for="catalog of catalogs">{{$t('catalog.' + catalog.type)}}</option>
                        </select>
                    </div>
                </div>
                <div class="column">

                </div>
            </div>
        </Panel>

        <div class="items" v-if="selectedCatalogId && selectedCatalog" :class="{company: !!companyId}">
            <div class="left-section">
                <table>
                    <tr>
                        <th>
                            <div class="category name">
                                <span>{{$t('statistics.param.category')}}</span>
                                <input type="text" v-model="categoryFilter" :placeholder="$t('search') + '...'">
                            </div>
                        </th>
                        <th>
                            <div class="product name">
                                <span>{{$t('items.item')}}</span>
                                <input type="text" v-model="itemFilter" :placeholder="$t('search') + '...'">
                            </div>
                        </th>
                    </tr>

                    <tr v-if="!companyId">
                        <td colspan="2" class="filler">&nbsp;</td>
                    </tr>

                    <tr class="item-tr" v-for="item of filteredItems">
                        <td class="category-name">{{$to(item.category.name)}}</td>
                        <td class="item-name">{{$to(item.item.name)}}</td>
                    </tr>
                </table>
            </div>
            <div class="right-section">
                <table>
                    <tr v-if="!companyId">
                        <th :colspan="filteredCompanies.length">
                            <div class="name">
                                <span>{{$t('companies.title')}}</span>
                                <input type="text" v-model="companyFilter" :placeholder="$t('search') + '...'">
                            </div>
                        </th>
                    </tr>
                    <tr v-if="companyId">
                        <th class="single-company">
                            <div class="name">{{$t('catalogs.product_status')}}</div>
                        </th>
                    </tr>
                    <tbody>
                        <tr v-if="!companyId">
                            <td class="company-name" v-for="company of filteredCompanies">{{company.name}}</td>
                        </tr>
                        <tr class="item-tr" v-for="item of filteredItems" :key="'item' + item.item.id + item.category.id">
                            <td v-for="company of filteredCompanies" :key="'company' + company.id + item.item.id + item.category.id">
                                <button class="btn" :class="{active: !isExcluded(item, company), inactive: isExcluded(item, company)}"
                                        @click="toggleExclusion(item, company)">
                                    <svgicon :src="isExcluded(item, company) ? 'icon/close.svg' : 'icon/check.svg'" :height="13" :width="13"></svgicon>
                                    {{$t(isExcluded(item, company) ? 'excluded' : 'included')}}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="footer-actions" v-if="selectedCatalogId && selectedCatalog">
            <button class="btn btn-primary" @click="save">{{$t('save')}}</button>
        </div>

    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
      name: "CompanyCatalogs",

      async mounted() {
        this.$store.state.pageTitleTranslationKey = "catalogs.title";
        this.$store.state.pageIcon = "/icon/menu.svg";

        showSpinner();
        this.inventory = await this.$store.getters.getContextInventory;
        if (this.inventory) {
            await this.initialize();
        }
        hideSpinner();
      },

      data() {
        return {
          inventory: null,
          selectedCatalogId: null,
          categoryFilter: "",
          itemFilter: "",
          companyFilter: "",
          items: [],
          catalogs: [],
          exclusions: [],
          companies: []
        }
      },

      computed: {
        selectedCatalog() {
          return this.catalogs.find(c => c.id === this.selectedCatalogId);
        },
        companyId() {
          return this.$route.query.company;
        },
        filteredItems() {
          if (!this.selectedCatalog) {
            return [];
          }
          let items = this.items.filter(i => this.selectedCatalog.selected.indexOf(i.id) > -1); //only have items for selected catalog
          if (this.itemFilter) {
            items = items.filter(i => this.$to(i.item.name).toLowerCase().indexOf(this.itemFilter.toLowerCase()) > -1);
          }
          if (this.categoryFilter) {
            items = items.filter(i => this.$to(i.category.name).toLowerCase().indexOf(this.categoryFilter.toLowerCase()) > -1)
          }
          return items;
        },
        filteredCompanies() {
          let companies = this.companies.filter(c => c.inventory === this.inventory.id);

          if (this.companyFilter) {
            companies = companies.filter(c => c.name.toLowerCase().indexOf(this.companyFilter) > -1);
          }

          return companies;
        }
      },

      methods: {
        ...mapActions(["getItemToCategories", "getCatalogs", "getCatalogCompanyExclusions", "postCatalogCompanyExclusions", "getCompanies"]),

        async initialize() {
          let [itemsResponse, catalogsResponse, exclusionsResponse, companiesResponse] = await Promise.all([
            this.getItemToCategories({inventoryId: this.inventory.id, active: 1}),
            this.getCatalogs({inventoryId: this.inventory.id}),
            this.getCatalogCompanyExclusions(this.inventory.id),
            this.getCompanies(this.$route.query.branch)
          ]);
          this.items = itemsResponse || [];
          this.catalogs = catalogsResponse || [];
          this.exclusions = exclusionsResponse ? exclusionsResponse.data : [];
          this.companies = companiesResponse || [];

          if (this.companyId) {
            this.companies = this.companies.filter(c => c.id.toString() === this.companyId);
          }

          if (this.catalogs.length === 1) {
            this.selectedCatalogId = this.catalogs[0].id;
          }

        },
        isExcluded(item, company) {
          let existingExclusion = this.exclusions.find(e => e.company === company.id && e.catalog === this.selectedCatalogId);
          if (existingExclusion) {
            return existingExclusion.excludedItcs.indexOf(item.id) > -1;
          } else {
            return false;
          }
        },
        toggleExclusion(item, company) {
          let isExcluded = this.isExcluded(item, company);
          let existingExclusion = this.exclusions.find(e => e.company === company.id && e.catalog === this.selectedCatalogId);
          if (isExcluded) {
            let exclusionIndex = existingExclusion.excludedItcs.indexOf(item.id);
            existingExclusion.excludedItcs.splice(exclusionIndex, 1);
          } else {
            if (existingExclusion) {
              existingExclusion.excludedItcs.push(item.id);
            } else {
              this.exclusions.push({
                company: company.id,
                catalog: this.selectedCatalogId,
                excludedItcs: [item.id]
              })
            }
          }
        },
        async save() {
          showSpinner();
          let response = await this.postCatalogCompanyExclusions(this.exclusions);
          hideSpinner();
          if (response) {
            toast(this.$t("inventory.success"), "success");
          } else {
            toast(this.$t("error.no_server"), "error");
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
    .items.company {
        .category-name {
            max-width: 350px;
        }
        .item-name {
            max-width: 500px;
        }
        .left-section {
            flex-grow: 1;
        }
        .right-section {
            overflow: initial;
        }
    }

    table {
        width: 100%;
        th .name {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            span {
                margin-bottom: 4px;
                padding-left: 14px;
            }

            input {
                font-size: 16px;
                width: 100%;
            }
        }
    }
    table th {
        padding-bottom: 20px;
        border-bottom: 1px solid #ccc;
        height: 93px;
    }
    th, td {
        padding: 6px 10px;
    }
    table th.single-company {
        padding-bottom: 0;
        padding-left: 15px;
    }
    td {
        height: 64px;
    }
    .item-tr {
        td {
            background-color: white;
            border-bottom: 8px solid #f2f2f2;
            border-top: 8px solid #f2f2f2;

            &:first-child {
                border-top-left-radius: 20px;
                border-bottom-left-radius: 20px;
                border-left: 8px solid #f2f2f2;
            }

            &:last-child {
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                border-right: 8px solid #f2f2f2;
            }
        }
    }
    .left-section .item-tr td:last-child {
        border-radius: 0;
        border-right: 0;
    }
    .right-section .item-tr td:first-child {
        border-radius: 0;
        border-left: 0;
    }
    .items {
        display: flex;

        .right-section {
            flex-grow: 1;
            overflow-x: auto;
        }
    }
    .category-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 300px;
    }
    .item-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 350px;
    }
    .company-name {
        min-width: 175px;
        text-align: center;
        font-weight: 500;
    }

    td .btn {
        width: 100%;
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: inherit;

        &.active {
            $color: #3baa43;
            color: $color;
            fill: $color;
            background-color: rgba(59, 170, 67, 0.03);
            border: 1px dashed rgba(59, 170, 67, 0.5);
        }

        &.inactive {
            $color: #ee0f00;
            color: $color;
            fill: $color;
            background-color: rgba(238, 15, 0, 0.03);
            border: 1px dashed rgba(238, 15, 0, 0.5);
        }

        .svgicon {
            margin-right: 10px;
        }
    }
</style>